module.exports = __webpack_public_path__ + "img/github-circle.cb9192f0.svg";